function addCollapseClass(selector) {
  const element = document.querySelector(selector);
  if (element && !element.classList.contains('collapse')) {
    element.classList.add('collapse');
  }
}

function removeCollapseClass(selector) {
  const element = document.querySelector(selector);
  if (element && element.classList.contains('collapse')) {
    element.classList.remove('collapse');
  }
}

module.exports = {
  addCollapseClass,
  removeCollapseClass,
};
